import { accountsBudgetsRouteProps } from 'src/navigation/routeProps'
import CreditCardsFullPaginatedDataReducer, {
  Actions as CreditCardsFullPaginatedDataActions,
  CreditCardsFullPaginatedDataState,
  initialState as initialCreditCardsFullPaginatedDataState,
} from 'src/redux/creditCardsFullPaginatedData.reducer'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import UsersFullPaginatedDataReducer, {
  Actions as UsersFullPaginatedDataActions,
  initialState as initialUsersFullPaginatedDataState,
  UsersFullPaginatedDataState,
} from 'src/redux/usersFullPaginatedData.reducer'

export interface AccountsBudgetsState {
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataState
  usersFullPaginatedData: UsersFullPaginatedDataState
}

export const initialState: AccountsBudgetsState = {
  creditCardsFullPaginatedData: initialCreditCardsFullPaginatedDataState,
  usersFullPaginatedData: initialUsersFullPaginatedDataState,
}

export type Actions =
  | CreditCardsFullPaginatedDataActions
  | UsersFullPaginatedDataActions

const CoreAccountsBudgetsReducer = (
  state = initialState,
  action: Actions,
): AccountsBudgetsState => ({
  creditCardsFullPaginatedData: CreditCardsFullPaginatedDataReducer(
    state.creditCardsFullPaginatedData,
    action as CreditCardsFullPaginatedDataActions,
  ),
  usersFullPaginatedData: UsersFullPaginatedDataReducer(
    state.usersFullPaginatedData,
    action as UsersFullPaginatedDataActions,
  ),
})

const AccountsBudgetsReducer = createBackgroundReducer(
  accountsBudgetsRouteProps,
  initialState,
  CoreAccountsBudgetsReducer,
)

export default AccountsBudgetsReducer
